export const TAB_SCROLL_SPEED = 15;
export const LEFT_TAB_SCROLL_STEP = -10;
export const RIGHT_TAB_SCROLL_STEP = 10;
export const DEFAULT_SCROLL_DISTANCE = 100;
